/**
 * Module-level relation label caches shared by table/relation UI.
 * Cleared on auth changes so another user cannot reuse resolved labels from a prior session.
 */
export const relationLabelCache: Record<string, Map<string, string>> = {}

/** Populated when loading the `users` relation for creator/owner columns (name + email). */
export const userUidDisplayCache: Map<string, { name: string; email: string }> = new Map()

export const userUidAuthFetchPromises: Map<string, Promise<void>> = new Map()

export function clearRelationLabelCache(): void {
    for (const slug of Object.keys(relationLabelCache)) {
        relationLabelCache[slug].clear()
    }
    userUidDisplayCache.clear()
    userUidAuthFetchPromises.clear()
}
